// extracted by mini-css-extract-plugin
export default {"row":"BaseParametersStyles_row__oyINE"};